import React from "react";
import { Box } from "@mui/material";
import ApprovalCard from "../ApprovalCard/ApprovalCard";
import { getOrdinal } from "../../utils/helper";

const  SubApprovalCard = ({
  taskItem,
  subTaskItem,
  setStartTaskOpen,
  handleStartTask,
  indx,
  handleClickTaskUpdate,
  handleViewThreadClick,
  tabValue,
  taskTabValue,
  labelNumber,
  userData,
  groupList,
  taskStatusLabels,
  onDragStart,
  onDragEnd,
  isDragging,
  draggedTask,
  setProfileViewModal,
  isProfileViewOpen,
  profileViewData,
  setProfileViewData,
  handleShowUserProfile,
  startTaskOpen,
}) => {
  return (
    <Box
      width="100%"
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: "0.5rem",
      }}
    >
      {/* Subtasks Container */}
      <Box
        sx={{
          flex: 1,
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: "19.5px",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          padding: "9px 20px 9px 12px",
          // backgroundColor:
          //   subIndex % 2 === 0 ? "rgba(222, 222, 222, 1)" : "#fffefeff",
        }}
      >
        {/* First SubTask - Design UI */}
        <ApprovalCard
          taskItem={taskItem}
          setStartTaskOpen={setStartTaskOpen}
          handleStartTask={handleStartTask}
          indx={indx}
          handleClickTaskUpdate={handleClickTaskUpdate}
          handleViewThreadClick={handleViewThreadClick}
          tabValue={tabValue}
          taskTabValue={taskTabValue}
          userData={userData}
          groupList={groupList}
          taskStatusLabels={taskStatusLabels}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          isDragging={isDragging && draggedTask?.id === taskItem?.id}
          setProfileViewModal={setProfileViewModal}
          isProfileViewOpen={isProfileViewOpen}
          profileViewData={profileViewData}
          setProfileViewData={setProfileViewData}
          handleShowUserProfile={handleShowUserProfile}
          startTaskOpen={startTaskOpen}
          levelLabel={getOrdinal(labelNumber)}
        />
      </Box>
    </Box>
  );
};

export default SubApprovalCard;
